import store from "@/store"

let addProductAtCardMap = new Map();
let ifAddToCartProceeding = false;
let ifCartSyncProceeding = false;
import {
    checkMaxBuyNum
} from "@/utils/common"

async function cartApiAddToCart(shopId, specificationId, num, productId, description) {
    try {
        //
        console.log("addToCart productId: " + productId + ", sid: " + specificationId);

        /**
         * 
         */
        if (!addProductAtCardMap.get(`${productId}_${specificationId}`)) {

            /**
             * calculate exist total num
             */
            while (ifCartSyncProceeding) {
                await new Promise(resolve => {
                    setTimeout(() => {
                        resolve();
                    }, 200);
                })
            }

            //
            let cartExistNum = 0;
            for (let cartItem of store.getters["cart/getCartInfo"](shopId).shoppingCars) {
                //
                console.log(`cartItem productId: ${cartItem.productInfo.pId}, sid: ${cartItem.specificationId}`);

                //
                if (cartItem.productInfo.pId == productId && cartItem.specificationId == specificationId) {
                    //
                    cartExistNum = cartItem.snum;

                    //
                    console.log("addToCart exist product, productId: " + productId + ", sid: " + specificationId + ", num: " + num);

                    //
                    break;
                }
            }
            
            //
            addProductAtCardMap.set(`${productId}_${specificationId}`, {
                number: cartExistNum,
            });
        }

        //
        const preNum = addProductAtCardMap.get(`${productId}_${specificationId}`).number;
        if (preNum + num > checkMaxBuyNum(shopId, productId, specificationId)) {
            return this.Toast(`当前商品最多购买${checkMaxBuyNum(shopId, productId, specificationId)}件`);
        }
        addProductAtCardMap.set(`${productId}_${specificationId}`, {
            number: preNum + num,
            ifNeedSync: true,
        });

        //
        if (ifAddToCartProceeding) {
            return;
        }
        ifAddToCartProceeding = true;

        //
        while (true) {
            for (let key of addProductAtCardMap.keys()) {

                // there is some product need sync
                if (addProductAtCardMap.get(key).ifNeedSync == true) {
                    //
                    for (let key of addProductAtCardMap.keys()) {
                        //
                        if (process.env.NODE_ENV == 'development') {
                            console.log(`cartApiAddToCart, ${key}`)
                        }

                        // check if need sync
                        const [pId, sId] = key.split("_");
                        const addProductAtCardValue = addProductAtCardMap.get(key);
                        if (addProductAtCardValue.ifNeedSync == false) {
                            continue;
                        }

                        //
                        addProductAtCardValue.ifNeedSync = false;
                        addProductAtCardMap.set(key, addProductAtCardValue);

                        //
                        const { statusCode, msg } = await this.axios.shop.get("/shoppingCarController/addProductToShoppingCar.do", {
                            pId: pId,
                            specificationsId: sId,
                            num: addProductAtCardValue.number, // note !!! this is the total number of the product which at card
                        })
                            
                        //
                        if(statusCode == "500")
                        {
                            this.Toast("请先进行登录");
                        }
                        else if (statusCode !== '200') {
                            //
                            this.Toast(`更新购物车失败, ${msg}`)
                        }
                    }

                    break;
                }
            }

            // there is no product need sync
            addProductAtCardMap = new Map()

            //
            ifAddToCartProceeding = false;

            break;
        }

        // 刷新购物车
        ifCartSyncProceeding = true;

        await new Promise((resolve, reject) => {
            this.$store.dispatch('cart/getCart', {
                shopId: shopId,
                forceUpdate: true,
                cb: e => {
                    if (e) {
                        reject(e)
                    }

                    resolve()
                },
            });
        })

        ifCartSyncProceeding = false;

        //
        if (description && description.length > 0) {
            this.Toast(description);
        }
    } catch (e) {
        //
        addProductAtCardMap = new Map();
        ifAddToCartProceeding = false;
        ifCartSyncProceeding = false;

        //
        this.Toast(`添加到购物车异常, ${e.toString()}`)
    }
}

export default {
    cartApiAddToCart,
}